<template>
  <div>
    <CRow>
      <CCol sm="12">
        <EventsTable
          :items="events"
          hover
          striped
          border
          small
          fixed
          caption="Eventos"
          ref="listEvents"
          @refreshItems="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import EventsTable from '../../components/events/EventsTable.vue'
import ws from '../../services/events';
import store from '../../store'

export default {
  name: 'EventsCatalog',
  components: { EventsTable },
  data: function () {
		return {
            events: []
        }
  },
  mounted: async function() {
    this.loading();
      await this.$refs.listEvents.changeFilters();    
    this.loaded();
  },
  methods: {
    async refreshItems (filters){
      this.loading();
        let response = await ws.get(filters);
        if(response.type == "success"){
          this.events = response.data;
        }
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
